// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

/**
 * How far a finger may wander and still be tapping. An Android touch reports a pixel or two of
 * movement on almost every tap, so a parent that claims the responder on the first move event
 * takes every tap away from the buttons inside it. Claim only once the finger has gone past this.
 */
export const TAP_SLOP_PX = 10;

type Point = { pageX: number; pageY: number };

export const movedPastTapSlop = (origin: Point | null, current: Point): boolean =>
  origin !== null && Math.hypot(current.pageX - origin.pageX, current.pageY - origin.pageY) > TAP_SLOP_PX;
